import { InputHTMLAttributes, forwardRef } from 'react';

type CheckboxProps = {
  label: string;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, ...props }, ref) => (
    <label
      className='flex items-center space-x-2 font-inter'
      htmlFor={`checkbox-${label.replace(/\s+/g, '-')}`}
    >
      <input
        id={`checkbox-${label.replace(/\s+/g, '-')}`}
        type='checkbox'
        ref={ref}
        {...props}
        className='form-checkbox h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500'
      />
      <span className='text-sm text-gray-700 font-inter'>{label}</span>
    </label>
  )
);

Checkbox.displayName = 'Checkbox';
